import i1 from "../gallery/1.jpeg";
import i2 from "../gallery/2.jpeg";
import i3 from "../gallery/3.jpeg";
import i4 from "../gallery/4.jpeg";
import i5 from "../gallery/5.jpeg";
import i6 from "../gallery/6.jpeg";
import i7 from "../gallery/7.jpeg";
import i8 from "../gallery/8.jpeg";
import i9 from "../gallery/9.jpeg";
import i10 from "../gallery/10.jpeg";
import i11 from "../gallery/11.jpeg";
import i12 from "../gallery/12.jpeg";
import i13 from "../gallery/13.jpeg";
import i14 from "../gallery/14.jpeg";
import i15 from "../gallery/15.jpeg";
import i16 from "../gallery/16.jpeg";
import i17 from "../gallery/17.jpeg";
import i18 from "../gallery/18.jpeg";
import i19 from "../gallery/19.jpeg";
import i20 from "../gallery/20.jpeg";
import i21 from "../gallery/21.jpeg";
import i22 from "../gallery/22.jpeg";
import i23 from "../gallery/23.jpeg";
import i24 from "../gallery/24.jpeg";
import i25 from "../gallery/25.jpeg";
import i26 from "../gallery/26.jpeg";
import i27 from "../gallery/27.jpeg";
import i28 from "../gallery/28.jpeg";
import i29 from "../gallery/29.jpeg";
import i30 from "../gallery/30.jpeg";
import i31 from "../gallery/31.jpeg";
import i32 from "../gallery/32.jpeg";
import i33 from "../gallery/33.jpeg";
import i34 from "../gallery/34.jpeg";
import i35 from "../gallery/35.jpeg";
import i36 from "../gallery/36.jpeg";
import i37 from "../gallery/37.jpeg";
import i38 from "../gallery/38.jpeg";
import i39 from "../gallery/39.jpeg";
import i40 from "../gallery/40.jpeg";
import i41 from "../gallery/41.jpeg";
import i42 from "../gallery/42.jpeg";
import i43 from "../gallery/43.jpeg";
import i44 from "../gallery/44.jpeg";
import i45 from "../gallery/45.jpeg";
import i46 from "../gallery/46.jpeg";
import i47 from "../gallery/47.jpeg";
import i48 from "../gallery/48.jpeg";
import i49 from "../gallery/49.jpeg";
import i50 from "../gallery/50.jpeg";
import i51 from "../gallery/51.jpeg";
import i52 from "../gallery/52.jpeg";
import i53 from "../gallery/53.jpeg";
import i54 from "../gallery/54.jpeg";
import i55 from "../gallery/55.jpeg";
import i56 from "../gallery/56.jpeg";
import i57 from "../gallery/57.jpeg";
import i58 from "../gallery/58.jpeg";
import i59 from "../gallery/59.jpeg";
import i60 from "../gallery/60.jpeg";
import i61 from "../gallery/61.jpeg";
import i62 from "../gallery/62.jpeg";
import i63 from "../gallery/63.jpeg";
import i64 from "../gallery/64.jpeg";
import i65 from "../gallery/65.jpeg";
import i66 from "../gallery/66.jpeg";
import i67 from "../gallery/67.jpeg";
import i68 from "../gallery/68.jpeg";
import i69 from "../gallery/69.jpeg";
import i70 from "../gallery/70.jpeg";
import i71 from "../gallery/71.jpeg";
import i72 from "../gallery/72.jpeg";
import i73 from "../gallery/73.jpeg";
import i74 from "../gallery/74.jpeg";
import i75 from "../gallery/75.jpeg";
import i76 from "../gallery/76.jpeg";
import i77 from "../gallery/77.jpeg";
import i78 from "../gallery/78.jpeg";
import i79 from "../gallery/79.jpeg";
import i80 from "../gallery/80.jpeg";
import i81 from "../gallery/81.jpeg";
import i82 from "../gallery/82.jpeg";
import i83 from "../gallery/83.jpeg";
import i84 from "../gallery/84.jpeg";
import i85 from "../gallery/85.jpeg";
import i86 from "../gallery/86.jpeg";
import i87 from "../gallery/87.jpeg";
import i88 from "../gallery/88.jpeg";
import i89 from "../gallery/89.jpeg";
import i90 from "../gallery/90.jpeg";
import i91 from "../gallery/91.jpeg";
import i92 from "../gallery/92.jpeg";
import i93 from "../gallery/93.jpeg";
import i94 from "../gallery/94.jpeg";
import i95 from "../gallery/95.jpeg";
import i96 from "../gallery/96.jpeg";
import i97 from "../gallery/97.jpeg";
import i98 from "../gallery/98.jpeg";
import i99 from "../gallery/99.jpeg";
import i100 from "../gallery/100.jpeg";

import s1 from "../images/slideshow/1.jpeg";
import s2 from "../images/slideshow/2.jpeg";
import s3 from "../images/slideshow/3.jpeg";
import s4 from "../images/slideshow/4.jpeg";
import s5 from "../images/slideshow/5.jpeg";
import s6 from "../images/slideshow/6.jpeg";
import s7 from "../images/slideshow/7.jpeg";

const images = [
	i1,
	i2,
	i3,
	i4,
	i5,
	i6,
	i7,
	i8,
	i9,
	i10,
	i11,
	i12,
	i13,
	i14,
	i15,
	i16,
	i17,
	i18,
	i19,
	i20,
	i21,
	i22,
	i23,
	i24,
	i25,
	i26,
	i27,
	i28,
	i29,
	i30,
	i31,
	i32,
	i33,
	i34,
	i35,
	i36,
	i37,
	i38,
	i39,
	i40,
	i41,
	i42,
	i43,
	i44,
	i45,
	i46,
	i47,
	i48,
	i49,
	i50,
	i51,
	i52,
	i53,
	i54,
	i55,
	i56,
	i57,
	i58,
	i59,
	i60,
	i61,
	i62,
	i63,
	i64,
	i65,
	i66,
	i67,
	i68,
	i69,
	i70,
	i71,
	i72,
	i73,
	i74,
	i75,
	i76,
	i77,
	i78,
	i79,
	i80,
	i81,
	i82,
	i83,
	i84,
	i85,
	i86,
	i87,
	i88,
	i89,
	i90,
	i91,
	i92,
	i93,
	i94,
	i95,
	i96,
	i97,
	i98,
	i99,
	i100,
];

const slideshow = [s1, s2, s3, s4, s5, s6, s7];

export default images;
export { slideshow };
